import {
  createObjectValidator,
  validateStringEnum,
  validateString,
  validateUuidV4
} from "../../../packages/validator/validator.js";

/**
 * A file associated with an entity.
 */
export type EntityFile = {
  /**
   * UUID v4 of the file.
   */
  fileId: string;
  /**
   * UUID v4 of the associated entity.
   */
  entityId: string;
  /**
   * Original file name.
   */
  filename: string;
  /**
   * Source of the file.
   */
  source: "accounting" | "calendar";
};

export const validateEntityFile = createObjectValidator<EntityFile>("EntityFile", {
  fileId: validateUuidV4,
  entityId: validateUuidV4,
  filename: validateString,
  source: validateStringEnum(["accounting", "calendar"])
});
